export default "__VITE_ASSET__DuvZzF3r__"